import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import "../assets/CSS/Dashboard.css";
import axiosInstance from "../axiosConfig";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";

function StockValuationRemarks() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [filters, setFilters] = useState({ searchQuery: "" });
  const [stockValuationLots, setStockValuationLots] = useState([]);  // For LOT_ID + RM_ITEM_NAMES
  const [availableRMItems, setAvailableRMItems] = useState([]);      // For filtered RM items after LOT selection
  

  
  const initialFormData = {
    Lot_Id: "",
    Remarks: "",
    Category: "",
    CreatedBy:"",
    RM_ITEM_NAME:"",
    Quantity:"",
  };
  const [formData, setFormData] = useState(initialFormData);

  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  const fetchData = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/valuations-Remark");
      setData(response.data);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    const { searchQuery } = filters;
    const lowerSearch = searchQuery.toLowerCase();
    const filtered = data.filter((item) =>
      [item.Lot_Id, item.Remarks, item.Category, item.CreatedBy, item.RM_ITEM_NAME, item.Quantity]
        .join(" ")
        .toLowerCase()
        .includes(lowerSearch)
    );
    setFilteredData(filtered);
  }, [filters, data]);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => setFormData(initialFormData);

  const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    alertPlaceholder.innerHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <strong>${type === "success" ? "Success!" : "Error!"}</strong> ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    setTimeout(() => (alertPlaceholder.innerHTML = ""), 2000);
  };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await axiosInstance.post("/api/valuations-Remark", formData);
//       showAlert("Remark added!", "success");
//       resetForm();
//       setShowModal(false);
//       fetchData();
//     } catch (error) {
//       showAlert("Failed to add remark.", "danger");
//     }
//   };
const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const user = JSON.parse(localStorage.getItem("user")); // Get logged-in user
  
      const payload = {
        ...formData,
        CreatedBy: user?.Name || "Unknown"
      };
  
      await axiosInstance.post("/api/valuations-Remark", payload);
      showAlert("Remark added!", "success");
      resetForm();
      setShowModal(false);
      fetchData();
    } catch (error) {
      showAlert("Failed to add remark.", "danger");
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!selectedRow) return;
    try {
      await axiosInstance.put(`/api/valuations-Remark/${selectedRow.Id}`, formData);
      showAlert("Remark updated!", "success");
      resetForm();
      setShowUpdateModal(false);
      fetchData();
    } catch (error) {
      showAlert("Failed to update.", "danger");
    }
  };

  // const handleDelete = async (id) => {
  //   if (!window.confirm("Delete this record?")) return;
  //   try {
  //     await axiosInstance.delete(`/api/valuations-Remark/${id}`);
  //     showAlert("Deleted successfully!", "success");
  //     fetchData();
  //   } catch (error) {
  //     showAlert("Failed to delete.", "danger");
  //   }
  // };

  useEffect(() => {
    const fetchLots = async () => {
      try {
        const response = await axiosInstance.get("/api/stock-valuation-lotID");
        setStockValuationLots(response.data);  // Save the LOT_ID and RM ItemNames
      } catch (error) {
        console.error("Error fetching stock valuation lot IDs:", error);
      }
    };
  
    fetchLots();
  }, []);
  

  const columns = [
    { name: "Lot ID", selector: (row) => row.Lot_Id, sortable: true },
    { name: "Item Name", selector: (row) => row.RM_ITEM_NAME || "N/A", sortable: true },
    { name: "Quantity", selector: (row) => row.Quantity || "N/A", sortable: true },
    { name: "Remarks", width:"200px", selector: (row) => (
        <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.Remarks}
        >
            {row.Remarks}
        </span>
    ), sortable: true },
    { name: "Category", selector: (row) => row.Category, sortable: true },
    { name: "Created By", selector: (row) => row.CreatedBy, sortable: true },
   
    {
      name: "Created Date", width:"156px",
      selector: (row) =>(
        <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row.CreationDate ? new Date(row.CreationDate).toLocaleString("en-GB") : "N/A"}
      >
        {row.CreationDate ? new Date(row.CreationDate).toLocaleString("en-GB") : "N/A"}
        </span>
      ),
      sortable: true,
    },
    // {
    //   name: "Actions",
    //   cell: (row) => (
    //     <>
    //       <button
    //         className="btn btn-outline-danger btn-sm me-2"
    //         onClick={() => handleDelete(row.Id)}
    //       >
    //         Delete
    //       </button>
    //     </>
    //   ),
    // },
  ];

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{height:"-webkit-fill-available"}}>
          <div id="alertPlaceholder"></div>
          <div className="container">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h3>Remarks</h3>
              <div>
                <button className="btn btn-outline-primary me-2" onClick={() => setShowModal(true)}>
                  Add Remark
                </button>
                <button
                  className="btn btn-outline-primary"
                  onClick={() => {
                    if (!selectedRow) return showAlert("Select a row!", "danger");
                    setFormData(selectedRow);
                    setShowUpdateModal(true);
                  }}
                >
                  Update Remark
                </button>
              </div>
            </div>
            <input
              type="text"
              name="searchQuery"
              className="form-control mb-3"
              placeholder="Search..."
              style={{ width: "auto" }}
              value={filters.searchQuery}
              onChange={(e) => setFilters({ ...filters, searchQuery: e.target.value })}
            />
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              selectableRows
              onSelectedRowsChange={(selected) =>
                setSelectedRow(selected.selectedRows[0] || null)
              }
            />
          </div>
        </main>
      </div>

      {(showModal || showUpdateModal) && (
        <div className="modal show" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {showModal ? "Add Remark" : "Update Remark"}
                </h5>
                <button className="btn-close" onClick={() => {
                  resetForm();
                  setShowModal(false);
                  setShowUpdateModal(false);
                }}></button>
              </div>
              <form onSubmit={showModal ? handleSubmit : handleUpdate}>
                <div className="modal-body">
                  {/* <div className="mb-3">
                    <label className="form-label">Lot ID</label>
                    <input
                      type="text"
                      name="Lot_Id"
                      className="form-control"
                      placeholder="Enter Lot ID"
                      value={formData.Lot_Id}
                      onChange={handleFormChange}
                      required
                    />
                  </div> */}
                  <div className="mb-3">
                  <label className="form-label">Lot ID</label>
                  <select
                    name="Lot_Id"
                    className="form-control"
                    value={formData.Lot_Id}
                    onChange={(e) => {
                      handleFormChange(e); // Update Lot_Id in formData
                      const selectedLot = stockValuationLots.find(
                        (lot) => lot.LOT_ID_NO === e.target.value
                      );
                      if (selectedLot) {
                        const items = selectedLot.RM_ItemNames.split(",").map(item => item.trim());
                        setAvailableRMItems(items);  // Set RM items for this lot
                      } else {
                        setAvailableRMItems([]);
                      }
                    }}
                    required
                  >
                    <option value="">Select Lot ID</option>
                    {stockValuationLots.map((lot, index) => (
                      <option key={index} value={lot.LOT_ID_NO}>
                        {lot.LOT_ID_NO} ({lot.ItemCount} items)
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                <label className="form-label">RM ITEM NAME</label>
                <input
                  type="text"
                  name="RM_ITEM_NAME"
                  className="form-control"
                  placeholder="Enter or select RM ITEM NAME"
                  value={formData.RM_ITEM_NAME}
                  onChange={handleFormChange}
                  list="rmItemOptions" // connect with datalist
                  required
                />
                <datalist id="rmItemOptions">
                  {availableRMItems.map((item, idx) => (
                    <option key={idx} value={item} />
                  ))}
                </datalist>
              </div>
                  <div className="mb-3">
                    <label className="form-label">Quantity</label>
                    <input
                      type="number"
                      name="Quantity"
                      className="form-control"
                      placeholder="Enter Lot ID"
                      value={formData.Quantity}
                      onChange={handleFormChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Remarks</label>
                    <textarea
                      name="Remarks"
                      className="form-control"
                      rows="3"
                      value={formData.Remarks}
                      placeholder="Enter Remark"
                      onChange={handleFormChange}
                      required
                    ></textarea>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Category</label>
                    <select
                      name="Category"
                      className="form-control"
                      value={formData.Category}
                      onChange={handleFormChange}
                      required
                    >
                      <option value="">Select Category</option>
                      <option value="Quality Issue">Quality Issue</option>
                      <option value="Short Qty">Short Qty</option>
                      <option value="Re-Work">Re-Work</option>
                      <option value="Change in BOM by Customer">Change in BOM by Customer</option>
                    </select>
                  </div>
                
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary">
                    {showModal ? "Submit" : "Update"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      resetForm();
                      setShowModal(false);
                      setShowUpdateModal(false);
                    }}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default StockValuationRemarks;
